export default "__VITE_ASSET__2d7829b7__"